import React from 'react';
import _ from 'lodash';
import r2wc from '@r2wc/react-to-web-component';
// import { Text, TextProps } from '@adc/ui-adc'
import Text from '@adc/ui-core/components/elementals/text';
import { getWebComponentName } from '../utils';
import { useShadowStyles } from '../hooks/useShadowStyles';
const WrappedComponent = props => {
    const ref = useShadowStyles();
    const newProps = {
        ..._.omit(props, 'styleOverride'),
        style: props?.styleOverride, // eslint-disable-line
    };
    return (React.createElement("div", { ref: ref },
        React.createElement(Text, { ...newProps },
            React.createElement("slot", null))));
};
const WebButton = r2wc(WrappedComponent, {
    props: {
        color: 'string',
        size: 'string',
        as: 'string',
        styleOverride: 'json',
    },
    shadow: 'open',
});
customElements.define(getWebComponentName('text'), WebButton);
